import React, { useEffect, useState } from 'react';
import { cardImages, formatCardNumber, getCardType } from '../../../global/utils/cardTypeConvert';
import { Input } from 'antd';

interface CardDetailProps {
    card: {
        id: string;
        last4: string;
        expiry: string;
        cvc?: string;
        actualCardNumber?: string;
    };
}

const CardDetail: React.FC<CardDetailProps> = ({ card }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const [cardType, setCardType] = useState<string>("");
    const [hidden, setHidden] = useState(true);

    const toggleExpand = () => {
        setIsExpanded(!isExpanded);
    };

    useEffect(() => {
        const cardNumber = card.actualCardNumber;
        setCardType(cardNumber ? getCardType(cardNumber) : "");
    }, [card.actualCardNumber]);

    return (
        <div className="border rounded-lg shadow-lg p-4 my-4">
            <div className="flex justify-between items-center">
                <div className="flex items-center">
                    {cardType && cardType !== "other" && (
                        <img
                            src={cardImages[cardType]}
                            alt={`${cardType} logo`}
                            className={`${cardType === "amex" ? "h-9 -ml-2 mr-4" : cardType === "visa" ? "h-6 mr-4" : "h-9 -ml-2 mr-2"} w-auto`}
                        />
                    )}
                    <div>
                        <p className="font-semibold">Visa **** {card.last4}</p>
                        <p className="text-gray-500">Expires {card.expiry}</p>
                    </div>
                </div>
                <button onClick={toggleExpand} className="focus:outline-none">
                    {isExpanded ? (
                        <svg className="w-6 h-6 transform rotate-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 15l7-7 7 7"></path>
                        </svg>
                    ) : (
                        <svg className="w-6 h-6 transform rotate-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                        </svg>
                    )}
                </button>
            </div>
            {isExpanded && (
                <div className="mt-4 space-y-5">
                    <div className="flex flex-col w-full gap-2">
                        <label htmlFor={`cardNumber-${card.id}`} className='text-primaryColor font-semibold text-sm'>Card Number</label>
                        <Input
                            id={`cardNumber-${card.id}`}
                            name={`cardNumber-${card.id}`}
                            placeholder='Card Number'
                            value={card?.actualCardNumber ? formatCardNumber(card.actualCardNumber, cardType) : ""}
                            className={`w-full border border-gray-300 rounded-md p-2 pr-10`}
                            disabled
                            type={hidden ? 'password' : 'text'}
                        />
                    </div>
                    <div className="flex justify-between gap-5">
                        <div className="flex flex-col w-full gap-2">
                            <label htmlFor={`expiry-${card.id}`} className='text-primaryColor font-semibold text-sm'>Expiry</label>
                            <Input
                                id={`expiry-${card.id}`}
                                name={`expiry-${card.id}`}
                                placeholder='MM/YY'
                                value={card?.expiry}
                                className='w-full border border-gray-300 rounded-md p-2'
                                disabled
                                type={hidden ? 'password' : 'text'}
                            />
                        </div>
                        <div className="flex flex-col w-full gap-2">
                            <label htmlFor={`cvv-${card.id}`} className='text-primaryColor font-semibold text-sm'>CVV</label>
                            <Input
                                id={`cvv-${card.id}`}
                                name={`cvv-${card.id}`}
                                placeholder='CVV'
                                value={card?.cvc}
                                className='w-full border border-gray-300 rounded-md p-2'
                                disabled
                                type={hidden ? 'password' : 'text'}
                            />
                        </div>
                    </div>
                    <div className="mt-4 flex justify-start gap-5 text-xs">
                        <button
                            className="bg-gray-200 rounded-lg min-w-[80px] py-2"
                            onClick={() => setHidden(!hidden)}
                        >
                            {hidden ? 'Unhide' : 'Hide'}
                        </button>
                        <button className="bg-black text-white rounded-lg min-w-[80px] py-2">Delete</button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default CardDetail;
